import React, { useCallback, useEffect, useState } from "react"
import { Refresh } from "@mui/icons-material"
import { useHistory } from "react-router-dom"
import Button from "../../../components/Button"
import { Routes } from "../../../constants"
import NotificationListMintCal from "../../../components/NotificationListMintCal"
import { useApi } from "../../../contexts/ApiContext"
import { CollectionStage, CollectionState, UserMetadata } from "../../../types"
import { useAuth } from "../../../contexts/AuthContext"
import NotificationList from "../../../components/NotificationList"
import { Blockchain } from "../ManageDraft/types"
import { useBlockchain } from "../../../contexts/blockchain"

const DeletedCollections = React.memo(() => {
  const history = useHistory()
  const {
    retrieveDeletedCollections,
  } = useApi()
  const { currentBlockchain, setCurrentBlockchain }: any = useBlockchain()


  const { getUserJWT, currentUserMetadata, setIsLoadingOverlayDisplay } = useAuth()
  const [deletedCollections, setDeletedCollections] = useState<any[]>([])

  const onRefresh = useCallback(async () => {
    setIsLoadingOverlayDisplay(true)
    const allDeleted: any = await retrieveDeletedCollections({ limit: 100 },currentBlockchain)
    setDeletedCollections(allDeleted)
    setIsLoadingOverlayDisplay(false)
  }, [getUserJWT,currentBlockchain])

  useEffect(() => {
    onRefresh()
  }, [currentBlockchain])

  return (
    <div className="flex flex-col w-11/12 mx-auto mb-12">
      <div className="mt-8 flex flex-row mb-4 justify-between sm:flex-row items-center">
        <div className="mb-4 sm:mb-0">
          <h1 className="font-black text-3xl text-left">
            DELETED COLLECTIONS
          </h1>
        </div>

        <div className="w-full sm:w-auto flex items-center space-x-4">
        <select required name="blockchain" className="rounded-xl mb-0 sm:mb-2 btn bg-kyzzen-secondary border border-r-8 border-kyzzen-secondary flex items-center text-white border-gray-400 hover:bg-kyzzen-secondary " onChange={(e) => setCurrentBlockchain(e.target.value)} value={currentBlockchain} >
            <option value={Blockchain.Solana}>Solana</option>
            <option value={Blockchain.Bitcoin}>Bitcoin</option>
          </select>
          <Button
            type="button"
            className="mb-0 sm:mb-2 w-auto btn bg-gradient text-kyzzen-primary flex items-center"
            onClick={onRefresh}
          >
            REFRESH
            <Refresh className="h-5 inline" />
          </Button>
        </div>
      </div>
      <div className="mb-4">
        <h2 className="text-lg sm:text-2xl my-4">ALL</h2>
        <NotificationList
          collections={deletedCollections}
          state={CollectionState.deleted}
        />
      </div>
    </div>
  )
})

export default DeletedCollections
